import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { TableCell, TableRow, Tooltip } from '@mui/material';

const FULL_COLUMN_SPAN = 17;
const DETAILED_COLUMN_COUNT = 4;

export function headerColumnSpan(showDetailed: boolean) {
  return showDetailed ? FULL_COLUMN_SPAN : FULL_COLUMN_SPAN - DETAILED_COLUMN_COUNT;
}

export function SearchHotelHead({ showDetailed }: { showDetailed: boolean }) {
  return (
    <TableRow
      sx={{
        '& .MuiTableCell-root': {
          whiteSpace: 'nowrap',
        },
      }}
    >
      <TableCell>
        <Tooltip title="Global ranking on anywhere search" placement="top" arrow>
          <InfoOutlinedIcon fontSize="small" aria-label="Global ranking on anywhere search" />
        </Tooltip>
      </TableCell>
      <TableCell sx={{ maxWidth: 200, width: 200 }}>Offer</TableCell>
      <TableCell align="right">Type</TableCell>
      <TableCell align="right">Views</TableCell>
      {showDetailed && <TableCell align="right">Recency weighted Views</TableCell>}
      <TableCell align="right">CTR</TableCell>
      <TableCell align="right">Sales #</TableCell>
      {showDetailed && <TableCell align="right">Recency weighted Sales</TableCell>}
      <TableCell align="right">Sales $</TableCell>
      <TableCell align="right">Margin $</TableCell>
      {showDetailed && <TableCell align="right">Recency weighted Margin</TableCell>}
      <TableCell align="right">Margin %</TableCell>
      <TableCell align="right">MPV</TableCell>
      <TableCell align="right">MPV + Sales</TableCell>
      {showDetailed && <TableCell align="right">Regional Sales + Global MPV</TableCell>}
      <TableCell align="right">Manual Score</TableCell>
      <TableCell align="right">Final score</TableCell>
    </TableRow>
  );
}
